import { useShow } from '../../../../hooks/useShow'
import { DialogContent, Modal } from '../../../../components/Modal/Modal'
import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { itemsQueryKey } from '../../../../api/queries'
import { ISpell } from '../../../../api/types/spell'
import { SpellForm } from '../SpellForm/SpellForm'

interface Props {
  children: (showModal: () => void) => any
  title: string
  spell?: ISpell
}

export const SpellFormModal: React.FC<Props> = ({ children, title, spell }) => {
  const { show, doHide, doShow } = useShow()
  const queryClient = useQueryClient()
  return (
    <>
      {children(doShow)}
      <Modal open={show} onClose={doHide} title={title}>
        <DialogContent>
          <SpellForm
            spell={spell}
            afterSuccess={() => {
              queryClient.invalidateQueries(itemsQueryKey())
              doHide()
            }}
          />
        </DialogContent>
      </Modal>
    </>
  )
}
